import html2pdf from "html2pdf.js";
import employeeLogo from "../../images/employee.png";
import moment from "moment";

export const InvoiceNewPrintedThermal = async ({ state, ledger = "" }) => {
  console.log('stateeee', state);
  console.log('ledgerrr', ledger );

  const temp = localStorage.getItem("template");
  const companyCode = localStorage.getItem("companyCode");
  const baseUrl = localStorage.getItem("base_url");
  const imgSrc = baseUrl || employeeLogo;
  const user = localStorage.getItem("username") || localStorage.getItem("token");
  const company = localStorage.getItem("company");
  const address = localStorage.getItem("address");
  const street = localStorage.getItem("street");
  const phone1 = localStorage.getItem("p1");
  const phone2 = localStorage.getItem("p2");
  const phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

  const rows = state.items
    .map((item, i) => {
      return `<tr>
        <td style=\"font-size: 14px; font-family: Arial, sans-serif; font-weight: bold; text-align: left;\">${
          item?.name || ""
        }</td>
        <td style=\"font-size: 12px; font-family: Arial, sans-serif; font-weight: bold; text-align: center;\">${
          item?.saleQuantity || 0
        }</td>
        <td style=\"font-size: 12px; font-family: Arial, sans-serif; font-weight: bold; text-align: center;\">${
          item?.price % 1 === 0 ? item?.price || 0 : item?.price.toFixed(3)
        }</td>
        <td style=\"font-size: 12px; font-family: Arial, sans-serif; font-weight: bold; text-align: center;\">${
          item.saleQuantity
            ? (item.saleQuantity * parseFloat(item.price)).toFixed(3)
            : (item.price || 0).toFixed(3)
        }</td>
      </tr>`;
    })
    .join("");

  const template = `
    <div style=\"text-align: center; max-width: 300px; margin: 0 auto; font-family: Arial, sans-serif;\">
      ${imgSrc ? `<img src='${imgSrc}' style='width: 100px; height: 100px;' alt='Company Logo' />` : ""}
      <h2 style=\"font-size: 16px; font-weight: bold; margin: 10px 0;\">${company || ""}</h2>
      <p style=\"margin: 0; font-size: 12px;\">${street || ""}, ${address || ""}</p>
      <p style=\"margin: 0; font-size: 12px;\">Phone: ${
        phone1 || phone2 ? `${phone1 || ""}${phone2 ? `, ${phone2}` : ""}` : phone || ""
      }</p>
        <p style=\"margin: 0; font-size: 12px;\">Customer: ${
       ledger?.new_ledger.name || state?.ledger?.name 
      }</p>
      <p style=\"margin: 10px 0; font-size: 12px;\">Invoice #: ${state?.invoiceNumber || ""}</p>
      <p style=\"margin: 0; font-size: 12px;\">Date: ${moment(state?.invoiceDate, "DD-MM-YYYY").format("DD-MM-YYYY")}</p>

      <table style=\"width: 100%; text-align: center; border-collapse: collapse; margin-top: 20px;\">
        <thead>
          <tr style=\"background-color: #f0f0f0; font-size: 12px;\">
            <th style=\"border: 1px solid #000; padding: 5px;\">Item</th>
            <th style=\"border: 1px solid #000; padding: 5px;\">Qty</th>
            <th style=\"border: 1px solid #000; padding: 5px;\">Rate</th>
            <th style=\"border: 1px solid #000; padding: 5px;\">Total</th>
          </tr>
        </thead>
        <tbody  style="border: 2px solid black;">
          ${rows}
        </tbody>
      </table>

      <div style=\"margin-top: 20px; text-align: right;\">
        <p style=\"margin: 0; font-size: 12px;\">Net Total: ${parseFloat(state?.total || 0).toFixed(3)}</p>
        <p style=\"margin: 0; font-size: 12px;\">Received: ${parseFloat(state?.recieved || 0).toFixed(3)}</p>
        <p style=\"margin: 0; font-size: 12px;\">Remaining: ${
          parseFloat(state?.total - state?.recieved || 0).toFixed(3)
        }</p>
      </div>

      <p style=\"margin-top: 20px; font-size: 12px; text-align: center;\">${terms}</p>

      <div style=\"margin-top: 20px; text-align: center;\">
        <span style=\"border-top: 1px solid #000; display: inline-block; padding-top: 5px;\">Authorized Signature</span>
      </div>
    </div>
  `;

  const element = document.createElement("div");
  element.innerHTML = template;
//   document.body.appendChild(element);

  const opt = {
    margin: 0,
    filename: "invoice.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: "mm", format: [80, 210], orientation: "portrait" },   };

  try {
    const blob = await html2pdf().from(element).set(opt).output("blob");
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        setTimeout(() => {
          newWindow.print();
        }, 1000);
      };
    } else {
      alert("Please allow popups for this website");
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};
